import { useAtom, useAtomValue } from "@effect-atom/atom-react";
import { MonacoEditor } from "./MonacoEditor";
import { TabBar } from "./TabBar";
import {
  xmlContentAtom,
  xslContentAtom,
  activeEditorTabAtom,
} from "../atoms";
import type { EditorTab } from "../lib/schemas";

const EDITOR_TABS: { id: EditorTab; label: string }[] = [
  { id: "xml", label: "XML Input" },
  { id: "xsl", label: "XSL Stylesheet" },
];

export function EditorPanel() {
  const [activeTab, setActiveTab] = useAtom(activeEditorTabAtom);
  const [xmlContent, setXmlContent] = useAtom(xmlContentAtom);
  const [xslContent, setXslContent] = useAtom(xslContentAtom);

  return (
    <div className="left-panel">
      <TabBar
        tabs={EDITOR_TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        className="editor-tabs"
      />
      <div className="editor-container">
        <div style={{ height: "100%", display: activeTab === "xml" ? "block" : "none" }}>
          <MonacoEditor
            value={xmlContent}
            onChange={setXmlContent}
            language="xml"
          />
        </div>
        <div style={{ height: "100%", display: activeTab === "xsl" ? "block" : "none" }}>
          <MonacoEditor
            value={xslContent}
            onChange={setXslContent}
            language="xsl"
          />
        </div>
      </div>
    </div>
  );
}
